import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-arrow-small",
  "use": "left-arrow-small-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol viewBox=\"0 0 7 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-arrow-small\">\n    <g id=\"left-arrow-small_cert-flow-2-3\" transform=\"translate(0, -8)\" fill-rule=\"nonzero\">\n        <polygon points=\"4.578 18.068 5.838 16.808 2.205 13.364 5.838 9.941 4.578 8.681 -1.31450406e-13 13.007 -1.31450406e-13 13.742\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol